import type { Unit } from "@stockline/shared/types/inventory/unit"
import type { OfflineResourceConfig } from "../../../types"
import { UNIT_TABLE } from "./db"

export const unitConfig: OfflineResourceConfig<Unit> = {
  name: "units",
  syncDisabled: false,
  endpoints: {
    full: "/api/v2/units",
    delta: "/api/v2/units/changes",
    push: "/api/v2/units/changes",
  },
  tableName: UNIT_TABLE,
  primaryKey: "id",
  indexes: {
    companyId: "companyId",
  },
  applyChange: (local, patch) => ({ ...local, ...patch }),
}
